import OffersWidgets from './OffersWidgets';

const Offers = ({ openCollapse, handleChangeCollapse, docsNumber, setDocsNumber }) => {
	return (
		<>
			<OffersWidgets
				openCollapse={openCollapse}
				handleChangeCollapse={handleChangeCollapse}
				docsNumber={docsNumber}
				setDocsNumber={setDocsNumber}
			/>
		</>
	);
};

export default Offers;
